// extracted by mini-css-extract-plugin
module.exports = {"desk":"Grid-module_desk_2WdR3","table":"Grid-module_table_2FVax","actions":"Grid-module_actions_ue1uM","dropdown":"Grid-module_dropdown_1mfV0","icon":"Grid-module_icon_2TFkr"};